"use client";
import { useAuthActions } from "@convex-dev/auth/react";
import { useConvexAuth } from "convex/react";
import { useState } from "react";

export function SignOutButton() {
  const { isAuthenticated } = useConvexAuth();
  const { signOut } = useAuthActions();
  const [isLoading, setIsLoading] = useState(false);

  if (!isAuthenticated) {
    return null;
  }

  const handleSignOut = async () => {
    setIsLoading(true);
    try {
      await signOut();
    } catch (error) {
      console.error("登出失败:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      className="flex items-center space-x-2 px-4 py-2 bg-stone-600 text-stone-100 rounded-full text-sm hover:bg-stone-700 transition duration-300 shadow-md active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
      onClick={handleSignOut}
      disabled={isLoading}
    >
      {isLoading ? (
        <>
          <div className="w-4 h-4 border-2 border-stone-100 border-t-transparent rounded-full animate-spin" />
          <span className="hidden sm:inline">退出中...</span>
        </>
      ) : (
        <span className="hidden sm:inline">退出</span>
      )}
    </button>
  );
}
